type AppearancePreference = 'auto' | 'light' | 'dark'

function normalizeAppearance(value: unknown): AppearancePreference {
  return value === 'light' || value === 'dark' ? value : 'auto'
}

export default defineNuxtPlugin(() => {
  const colorMode = useColorMode()
  const userStore = useUserStore()

  const setUserAppearance = (appearance: AppearancePreference) => {
    if (!userStore.user) {
      return
    }

    userStore.setUserLocal({
      ...userStore.user,
      appearance,
    })
  }

  const applyAppearance = (value: unknown) => {
    const appearance = normalizeAppearance(value)

    // @nuxt/color-mode nomme « system » le suivi du thème de l'OS (« auto » n'y est pas reconnu)
    const preference = appearance === 'auto' ? 'system' : appearance

    if (colorMode.preference !== preference) {
      colorMode.preference = preference
    }
  }

  const syncAppearanceFromProfile = async () => {
    if (!userStore.user?.id) {
      applyAppearance('auto')
      return
    }

    if (userStore.user.appearance !== null && userStore.user.appearance !== undefined) {
      applyAppearance(userStore.user.appearance)
      return
    }

    try {
      const profile = await $fetch<{ appearance?: string }>('/api/account/profile')
      const appearance = normalizeAppearance(profile?.appearance)

      setUserAppearance(appearance)
      applyAppearance(appearance)
    }
    catch {
      applyAppearance('auto')
    }
  }

  watch(() => userStore.user?.appearance, value => applyAppearance(value), {
    immediate: true,
  })

  watch(() => userStore.user?.id, () => {
    void syncAppearanceFromProfile()
  }, {
    immediate: true,
  })
})
